var _jsxFileName = "/codebuild/output/src1744610141/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/OTPInput/index.tsx";
import React, { memo } from 'react';
import { CharacterTextInput, IconValidationInvalid } from '@adc/parallax-component-library';
const OTPInput = /*#__PURE__*/memo(({
  isInvalid = false,
  label = '',
  errorMessage,
  value,
  disabled,
  testID,
  length,
  width,
  onValueChange
}) => {
  const showErrorMessage = isInvalid && errorMessage;
  return /*#__PURE__*/React.createElement(CharacterTextInput, {
    length: length,
    "aria-label": label ?? '',
    label: label,
    error: isInvalid,
    supportingText: showErrorMessage ? errorMessage : undefined,
    testID: testID,
    disabled: disabled,
    value: value,
    onValueChange: onValueChange,
    width: width,
    supportingIconConfig: showErrorMessage ? {
      icon: /*#__PURE__*/React.createElement(IconValidationInvalid, {
        testID: `${testID}-icon`,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43,
          columnNumber: 23
        }
      }),
      color: '$support.danger.surfaceOnColorAlt'
    } : undefined,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 7
    }
  });
});
OTPInput.displayName = 'OTPInput';
export { OTPInput };